/* global window */

window.dataLayer = window.dataLayer || [];

export const viewItemList = (payload, currency) => {
  const { collection, products } = payload;
  const items = products.map((p, index) => {
    const variant = p.variants?.[0];
    return {
      currency,
      item_name: p.title,
      item_image_url: p.image,
      item_id: variant?.sku || p.id,
      price: variant && variant.addToCartPrice / 100,
      item_category: collection.title,
      item_variant: variant?.title,
      item_list_name: collection.title,
      index
    };
  });

  const gtmPayload = {
    event: 'view_item_list',
    ecommerce: {
      items
    }
  };

  window.dataLayer.push(gtmPayload);
};

export const viewItem = (product, currency) => {
  const variant = product.variants?.[0];
  const payload = {
    event: 'view_item',
    ecommerce: {
      items: [
        {
          currency,
          item_name: product.title,
          item_image_url: product.image,
          item_id: variant?.sku || product.id,
          price: variant && variant.addToCartPrice / 100,
          item_variant: variant?.title
        }
      ]
    }
  };

  window.dataLayer.push(payload);
};

export const selectItem = (product, currency) => {
  const variant = product.variants?.[0];
  const payload = {
    event: 'select_item',
    ecommerce: {
      items: [
        {
          currency,
          item_name: product.title,
          item_id: variant?.sku || product.id,
          price: variant && variant.addToCartPrice / 100,
          item_variant: variant?.title
        }
      ]
    }
  };

  window.dataLayer.push(payload);
};

export const selectPromotion = (coupon, currency) => {
  const payload = {
    event: 'select_promotion',
    ecommerce: {
      promotions: [
        {
          currency,
          promotion_id: coupon.couponId,
          promotion_name: coupon.title,
          discount: coupon.totalValue / 100
        }
      ]
    }
  };

  window.dataLayer.push(payload);
};

export const addToCart = (item, currency) => {
  const payload = {
    event: 'add_to_cart',
    ecommerce: {
      items: [
        {
          currency,
          item_name: item.productTitle,
          item_id: item.sku,
          price: item.price / 100,
          item_variant: item.productVariantTitle,
          quantity: item.quantity
        }
      ]
    }
  };

  window.dataLayer.push(payload);
};

export const removeFromCart = (item, currency) => {
  const payload = {
    event: 'remove_from_cart',
    ecommerce: {
      items: [
        {
          currency,
          item_name: item.productTitle,
          item_id: item.sku,
          price: item.price / 100,
          item_variant: item.productVariantTitle
        }
      ]
    }
  };
  window.dataLayer.push(payload);
};

export const viewCart = (cart, currency) => {
  const ecommerce = getEcommercePayload(cart, currency);

  const payload = {
    event: 'view_cart',
    ecommerce
  };

  window.dataLayer.push(payload);
};

export const checkoutStep = (cart, currency, step) => {
  const ecommerce = getEcommercePayload(cart, currency);

  const payload = {
    event: step,
    ecommerce
  };

  window.dataLayer.push(payload);
};

export const purchase = (cart, currency) => {
  const ecommerce = getEcommercePayload(cart, currency);

  ecommerce.transaction_id = cart.orderNumber;

  const payload = {
    event: 'purchase',
    ecommerce
  };

  window.dataLayer.push(payload);
};

const getEcommercePayload = (cart, currency) => {
  if (!cart.items) {
    cart.items = [];
    cart.promotions = [];
    cart.coupons = [];
    cart.taxes = [];
    cart.shipping = [];
    cart.tenders = [];
    cart.total = 0;
  }
  const items = cart.items.map((item) => ({
    currency,
    item_name: item.productTitle,
    item_id: item.sku,
    price: item.price / 100,
    item_variant: item.productVariantTitle,
    quantity: item.quantity
  }));

  let promosOrCoupons = [...cart.promotions, ...cart.coupons];
  promosOrCoupons = promosOrCoupons.filter((promo) => promo.inUse === true);
  const promotions = promosOrCoupons.map((promo) => {
    const promotion = {
      currency,
      title: promo.title,
      code: promo.code,
      discount: promo.totalValue / 100
    };
    return promotion;
  });
  const taxTotal = cart.taxes.reduce((total, tax) => {
    if (tax.isIncludedInPrice) {
      return total;
    }
    return total + tax.price;
  }, 0);
  const shippingTotal = cart.shipping.reduce(
    (total, ship) => total + ship.price,
    0
  );
  const payload = {
    currency,
    value: cart.total / 100,
    tax: taxTotal / 100,
    shipping: shippingTotal / 100,
    payment_type: 'Credit Card',
    items,
    promotions
  };

  if (cart.shipping.length > 0) {
    payload.shipping_tier = cart.shipping[0].title;
  }
  if (cart.tenders.length > 0) {
    payload.payment_type = cart.tenders[0].tenderType;
  }

  return payload;
};
